import { Button } from "@mui/material";
import { forwardRef } from "react";
import CloseIcon from '@mui/icons-material/Close';

export const ButtonClose = forwardRef((props, ref) => {
  return (
    <Button
      ref={ref}
      startIcon={<CloseIcon />}
      {...props}
    >
      Chiudi
    </Button>
  );
});
